export const tractorZoneLayers = [
  {
    type: 'fill',
    metadata: {
      'lja:identify': {
        'layer-name': 'Tractor Area Cycle',
        'title-field': 'zone',
        attributes: [
          {
            kind: 'text',
            label: 'Zone',
            field: 'zone',
          },
          {
            kind: 'text',
            label: 'Tractors',
            field: 'tractors',
          },
          {
            kind: 'text',
            label: 'Location',
            field: 'location',
          },
          {
            kind: 'text',
            label: 'First Cycle',
            field: 'cycle1',
          },
          {
            kind: 'text',
            label: 'Second Cycle',
            field: 'cycle2',
          },
          {
            kind: 'text',
            label: 'Third Cycle',
            field: 'cycle3',
          },
          {
            kind: 'text',
            label: 'Fourth Cycle',
            field: 'cycle4',
          },
          {
            kind: 'text',
            label: 'Fifth Cycle',
            field: 'cycle5',
          },
        ],
      },
    },
    paint: {
      'fill-color': [
        'match',
        ['get', 'zone'],
        'Tractor Area No. 1',
        'hsl(327, 7%, 25%)',
        'Tractor Area No. 2',
        'hsl(203, 28%, 33%)',
        'Tractor Area No. 3',
        'hsl(152, 24%, 55%)',
        'Tractor Area No. 4',
        'hsl(73, 84%, 60%)',
        'transparent',
      ],
      'fill-opacity': 0.3,
    },
  },
  {
    type: 'fill',
    paint: {
      'fill-color': 'rgba(24, 255, 255, 1)',
      'fill-opacity': ['case', ['boolean', ['feature-state', 'lja:highlight'], false], 0.6, 0],
    },
  },
  {
    type: 'line',
    paint: {
      'line-color': 'rgba(255, 255, 255, 1)',
      'line-width': {
        stops: [
          [10, 0.5],
          [13, 2],
          [15, 4],
        ],
      },
      'line-opacity': 0.8,
    },
  },
  {
    type: 'symbol',
    minzoom: 8.5,
    layout: {
      'text-line-height': 1.1,
      'text-size': [
        'interpolate',
        ['cubic-bezier', 0.2, 0, 0.9, 1],
        ['zoom'],
        8,
        12,
        10,
        14,
        12,
        16,
      ],
      'text-font': ['DIN Pro Regular', 'Arial Unicode MS Regular'],
      'text-justify': 'center',
      'text-field': ['get', 'zone'],
      'text-max-width': 7,
      'symbol-placement': 'point',
    },
    paint: {
      'text-color': 'rgba(0, 0, 0, 1)',
      'text-halo-color': 'rgba(255, 255, 255, 0.5)',
      'text-halo-width': 1,
      'text-halo-blur': 1,
    },
  },
];
